import React, { useState } from "react";
import "./signup.scss";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Signup, Login } from "../../services/userService";
import Logo from "../../assets/images/logo.svg";
import ShowPass from "../../assets/images/showPass.svg";
import HidePass from "../../assets/images/hidePass.svg";
import SubmitButton from "../submitButton/submitButton";

function SignupComponent() {
  let navigate = useNavigate();
  const [showPassword, setShowpassword] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullNameError, setFullNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loading, setLoadig] = useState(false);
  const fullNameRegex = /^[آ-ی\s]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handlePasswordVisibility = () => {
    setShowpassword(!showPassword);
  };

  const handleFullName = (e) => {
    setFullNameError(false);
    if(fullNameRegex.test(e.target.value) || e.target.value === "") {
      setFullName(e.target.value);
    } else {
      setFullNameError(true);
    }
  };

  const handleEmail = (e) => {
    setEmailError(false);
    if(emailRegex.test(e.target.value) || e.target.value === "") {
      setEmail(e.target.value);
    } else {
      setEmailError(true);
    }
  };
  
  const handlePassword = (e) => {
    setPasswordError(false);
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (fullName === "") {
      setFullNameError(true);
    }
    if (email === "") {
      setEmailError(true);
    }
    if (password === "") {
      setPasswordError(true);
    }
    if (fullName !== "" && email !== "" && password !== "") {
      if (emailRegex.test(email) && fullNameRegex.test(fullName)) {
        try {
          setLoadig(true);
          await Signup(fullName, email, password);
          let res = await Login(email.toLocaleLowerCase(), password);
          setLoadig(false);
          localStorage.setItem("token", res.token);
          localStorage.setItem("fullname", res.fullname);
          localStorage.setItem("role", res.role);
          localStorage.removeItem("searched");
          navigate("/dashboard");
        } catch (err) {
          setLoadig(false);
          toast.error(err.error, { toastId: "error" });
        }
      } 
    }
  };

  return (
    <div className="signup">
      <div className="signupContent">
        <div className="content">
          <img src={Logo} alt="logo" />
          <div className="title">کارماراتو مدیریت کن</div>
          <p>اطلاعات زیر رو وارد کن</p>
        </div>
        <form>
        <label
            className={fullNameError ? "labelError" : ""}
            htmlFor="fullName"
          >
            نام و نام خانوادگی
          </label>
          <input
            className={fullNameError ? "inputError" : ""}
            type="text"
            onChange={(e) => handleFullName(e)}
            id="fullName"
            name="fullName"
            placeholder="اسم و فامیلت رو به پارسی اینجا بنویس"
            autoFocus
          />
          <label
            className={emailError ? "labelError" : ""}
            htmlFor="email"
          >
            ایمیل
          </label>
          <input
            className={emailError ? "inputError" : ""}
            type="email"
            onChange={(e) => handleEmail(e)}
            id="email"
            name="email"
            placeholder="ایمیلت رو اینجا بنویس"
          />
          <label
            className={passwordError ? "passwordLabelError" : ""}
            htmlFor="password"
          >
            کلمه عبور
          </label>
          <div
            className={passwordError ? "passwordError" : "passwordContainer"}
          >
            <input
              type={showPassword ? "text" : "password"}
              onChange={handlePassword}
              id="password"
              name="password"
              placeholder="کلمه عبور دلخواه خودت رو اینجا بنویس"
            />
            <img
              src={showPassword ? ShowPass : HidePass}
              onClick={handlePasswordVisibility}
              alt="icon"
            />
          </div>
          <SubmitButton onClick={handleSubmit} text="ثبت نام و ورود" loading={loading} />
          <div className="options flex justify-center rtl">
            <div  onClick={() => {
              navigate("/");
            }}>
              قبلا ثبت نام کردی؟  ورود
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
export default SignupComponent;
